export const scrollToSection = (id: string): void => {
  const element = document.getElementById(id);
  if (element) {
    const headerOffset = 60; // Adjust this value to match your header height
    const elementPosition =
      element.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }
};
